import { Box } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { CurrencyType } from '@tiendanube/common';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList, Text } from '@tiendanube/components';
import { CurrencyPrice } from 'commons/components';

interface Attributes {
  currency: CurrencyType;
  total: number;
}

function OrderSubtotalAmountRow({
  total,
  currency,
}: Readonly<Attributes>): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS);
  return (
    <DataList.Row id="total" grayed>
      <DataList.Cell width={70}>
        <Box display="flex" flexDirection="row" gap="0-5">
          <Text bold>
            {t('orderSummaryCard.tableAmounts.totalBeforeRefund')}
          </Text>
        </Box>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          price={total}
          currency={currency}
          block
          textAlign="right"
          bold
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderSubtotalAmountRow;
